import type { RouteObject } from 'react-router';
import { PageApercuVersion } from './PageApercuVersion';
import { PageComparaisonVersions } from './PageComparaisonVersions';
import { PageDemarche } from './PageDemarche';
import { PageDemarches } from './PageDemarches';
import { PageEditeurVersion } from './PageEditeurVersion';

export const routesDemarches: RouteObject[] = [
  { path: '/demarches', element: <PageDemarches /> },
  { path: '/demarches/:id', element: <PageDemarche /> },
  { path: '/demarches/:id/comparaison', element: <PageComparaisonVersions /> },
  { path: '/demarches/:id/versions/:v', element: <PageEditeurVersion /> },
  { path: '/demarches/:id/versions/:v/apercu', element: <PageApercuVersion /> },
];
